export const IconSizes = {
  STANDARD: 30,
};
